export default __webpack_public_path__ + "images/a2967558bf7303b78b3548fb800795ab-plus.svg";